var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:[
    'text-sm',
    'hover:bg-teal-300',
    'hover:cursor-pointer',
    { 'bg-gray-200': _vm.index % 2 === 0 },
    { 'bg-yellow-200': _vm.data['fzgReserviertInfo'] },
    { 'text-gray-500': _vm.data['fzgReserviertInfo'] } ],on:{"dblclick":function($event){return _vm.openJR(_vm.data['fzg_id'])}}},_vm._l((_vm.columns),function(s){return _c('table-column',{key:s.id},[_vm._v(_vm._s(_vm.data[s.name] ? _vm.data[s.name] : ""))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }